// @ts-nocheck
import React, { useState, useRef } from 'react'
import Papa from 'papaparse';
import goatStyleImage from '../../assets/images/goat-style.png';

const PromptArea = ({onSubmit, onCancel, errorMessage = null}) => {
    const [textState, setTextState] = useState("")
    const fileInputRef = useRef(null);
  // Centralized state for file info
  // fileType: "none" | "json" | "csv"
  const [fileInfo, setFileInfo] = useState({
    name: '',
    fileType: 'none',
    data: null
  });

  // Trigger the hidden file input
  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  // Handle file selection
  const handleFileChange = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      return;
    }

    const file = e.target.files[0];
    const reader = new FileReader();

    // Always store the filename immediately
    setFileInfo({
      name: file.name,
      fileType: 'none',
      data: null
    });

    reader.onload = (event) => {
      const text = event.target.result;
      try {
        // If the file name ends with ".json", parse as JSON
        if (file.name.endsWith('.json')) {
          const jsonData = JSON.parse(text);
          setFileInfo({
            name: file.name,
            fileType: 'json',
            data: JSON.stringify(jsonData, null, 2)
          });
        }
        // If the file name ends with ".csv", parse as CSV
        else if (file.name.endsWith('.csv')) {
          const result = Papa.parse(text, { header: true })
          setFileInfo({
            name: file.name,
            fileType: 'csv',
            data: JSON.stringify(result.data, null, 2)
          });
        }
        // If the file is neither JSON nor CSV
        else {
          throw new Error('Unsupported file type');
        }
      } catch (error) {
        console.error('Error parsing file:', error);
      }
    };

    // Read the file as text
    reader.readAsText(file);
  };

  const handleCancel = () => {
    setFileInfo({
      name: '',
      fileType: 'none',
      data: null
    })
  }

  const handleSubmit = () => {
    if(textState.trim().length !== 0) {
      onSubmit({
        objective:textState,
        fileInfo
      })
    }
  }

  return (
    <div className="flex mt-5">
      <div className="w-full max-w-3xl mx-auto">
        <div className="flex flex-col items-center">
          <img 
            src={goatStyleImage} 
            alt="Goat Style" 
            className="w-[240px] h-[240px] rounded-xl mb-5"
          />
        </div>
        <div className="text-gray-900 flex flex-col items-center text-5xl font-bold font-['Inter'] mb-5">
          Let's take action on weather.
        </div>
        <div className="text-gray-700 flex flex-col items-center text-md font-medium font-['Inter'] mb-3">
          Introducing the meteorologist you never knew you needed.
        </div>
        
        {errorMessage && (
          <div className="text-red-500 flex flex-col items-center text-md font-medium font-['Inter'] bg-red-50 p-4 rounded-lg border border-red-200 mb-4">
            <div className="font-bold">Error Processing Request</div>
            <div>{errorMessage}</div>
            <div className="text-sm mt-1">Please try again with a different prompt. Our support team has been notified.</div>
          </div>
        )}
        <textarea 
          className='p-4 w-full border border-gray-300 rounded-md my-2 h-[200px] rounded-lg focus:outline-none focus:ring-2 focus:ring-eai-primary-accent focus:border-transparent resize-none overflow-auto' 
          value={textState} 
          onChange={(e)=> setTextState(e.target.value)}
          placeholder="Describe in detail where, what and when you want to forecast." 
        />
        
        <div className='flex flex-wrap items-center mt-4'>
          {/* File name display */}
          {/* <div className='flex items-center grow'>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={handleFileChange}
              accept=".json, .csv"
            />
            <button 
              className='rounded-full bg-gray-500 hover:bg-gray-400 text-white py-2 px-4 text-sm font-semibold hover:cursor-pointer'
              onClick={handleButtonClick}
            >
              Attach File
            </button>
            {fileInfo.name && <div className='ml-3 text-sm text-gray-600'>{fileInfo.name}</div>}
          </div> */}
          
          {/* Action buttons */}
          <div className='flex flex-row grow space-x-3 mt-4 sm:mt-0'>
            <button 
              className='flex-grow eai-btn my-1' 
              // onClick={onCancel}
              onClick={()=> setTextState('')}
            >
              <div className="mx-3">Cancel</div>
            </button>
            <button
              disabled={textState.trim().length === 0} 
              className={`flex-grow eai-btn-grn my-1 ${textState.trim().length === 0 ? "cursor-not-allowed" : "cursor-pointer"}`} 
              onClick={handleSubmit}
            >
              <div className="mx-2">Start Forecasting</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PromptArea